import React from 'react';

import { UserKpiSettingsProps } from '../../types';

export const UserKpiSettings: React.FC<UserKpiSettingsProps> = () => {
    return <div />;
};
